import { BitmapText, Container } from '@pixi/react'
import { BitmapText as PixiBitmapText } from 'pixi.js'
import { memo, useMemo, useRef } from 'react'
import { SpinePlayer } from '@slot-nx/core'
import { useGodziDropStore } from '../../domain/godziDrop/store/godziDropStore'

interface GodziSpinButtonProps {
  x: number
  y: number

}
export const GodziSpinButton = memo((props: GodziSpinButtonProps) => {
  const roundTextRef = useRef<PixiBitmapText>()
  const [isShowFreeSpinBtn, freeSpinCount] = useGodziDropStore(state => [state.isShowFreeSpinBtn, state.freeSpinCount])

  const godziRoundContent = useMemo(() => {
    return (
      <BitmapText
        key="roundText"
        name="roundText"
        text={freeSpinCount.toString()}
        x={75}
        y={75}
        style={{ fontName: 'GodziFont', fontSize: 20, align: 'center' }}
        anchor={[0.5, 2]}
        ref={(el: PixiBitmapText) => {
          roundTextRef.current = el
        }}
      />
    )
  }, [freeSpinCount])

  return (
    <Container x={props.x} y={props.y}>
      <Container
        name="GodziSpinButton"
        x={10}
        y={205}
        scale={1.5}
        visible={isShowFreeSpinBtn}
      >

        <SpinePlayer
          x={75}
          y={75}
          data="godziFreeSpinSkel"
          atlas="godziFreeSpinAtlas"
          loop={true}
          animationStr="animation"
          scale={0.3}

        />
        {godziRoundContent}

      </Container>
    </Container>

  )
})
